<template>
  <v-alert
    border="left"
    colored-border
    color="red accent-4"
    elevation="2"
    :dismissible="true"
    type="error"
    :value="isShowError"
  >
    {{ ErrorCount }} Errors found in file submitted:
    <ul id="v-for-object" class="demo">
      <li style="color:red;" v-for="value in Errors" :key="value">
        {{ value }}
      </li>
    </ul>
  </v-alert>
</template>

<script>
export default {
  props: {
    ErrorCount: {
      type: Number,
      default: 0,
      required: true
    },
    Errors: {
      type: Array,
      required: true
    },
    isShowError: {
      type: Boolean,
      default: false,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.v-alert {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}
</style>
